<template>
  <b-container>
    <b-row align-h="center" class="mt-5">
      <b-col cols="12">
        <b-card-header class="card-main-header">
          <h3 class="text-center">Creating</h3>
        </b-card-header>
        <b-card class="card-main p-3 text-center">

          <b-row class="mb-3">
            <b-col sm="2">
              <label for="input-username">Username:</label>
            </b-col>
            <b-col sm="4">
              <b-form-input v-model="user.username" class="input-dark" id="input-username" size="sm"></b-form-input>
            </b-col>
            <template v-if="!user.permanent">
            <b-col sm="2">
              <label for="input-expiration">Expiration Date:</label>
            </b-col>
            <b-col sm="4">
              <b-form-datepicker v-model="user.expiration_date" local="en" class="input-dark" id="input-expiration" size="sm" type="date"></b-form-datepicker>
            </b-col>
            </template>
          </b-row>

          <b-row class="mb-3">
            <b-col sm="2">
              <label for="input-discord">DiscordID:</label>
            </b-col>
            <b-col sm="4">
              <b-form-input v-model="user.discord_id" class="input-dark" id="input-discord" size="sm"></b-form-input>
            </b-col>
            <b-col sm="2">
              <label for="input-discord">SteamID:</label>
            </b-col>
            <b-col sm="4">
              <b-form-input v-model="user.steam_id" class="input-dark" id="input-steam" size="sm"></b-form-input>
            </b-col>
          </b-row>

          <b-row class="mb-5">
            <b-col sm="2">
              <label for="input-discord">Rank:</label>
            </b-col>
            <b-col sm="4">
              <b-form-select v-model="user.plan_id">
                <b-form-select-option :value="null">Please select an option</b-form-select-option>
                <b-form-select-option v-for="plan in plans" v-bind:key="plan.plan_id" :value="plan.plan_id">{{ plan.name }}</b-form-select-option>
              </b-form-select>
            </b-col>
            <b-col sm="2">
              <label for="input-permanent">Is Permanent:</label>
            </b-col>
            <b-col sm="1">
              <b-form-checkbox id="input-permanent" v-model="user.permanent"></b-form-checkbox>
            </b-col>
          </b-row>

          <button class="btn btn-md btn-primary float-right" v-on:click="createUser">
            Create
          </button>

          <a href="/admin" class="btn btn-md btn-secondary float-left">
            Back
          </a>
        </b-card>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
// APIs
import PlanApi from "@/services/PlanApi";
import UserApi from "@/services/UserApi";

// Event Bus
import EventBus from "@/services/EventBus";

export default {
  async created() {
    try {
      this.plans = await PlanApi.getPlans();
    } catch (err) {
      this.error = err.message;
    }
  },
  data() {
    return {
      user: [],
      plans: [],
    };
  },
  methods: {
    createUser() {
      UserApi.createUser(this.user)
      .then(res => {
        EventBus.$emit('Success', res);
        this.user = [];
      })
      .catch(error => {
        EventBus.$emit('Error', error);
      });
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Admin/User/Create.vue